/**
 * Production-safe logging utility
 * Reduces console noise in production while maintaining error visibility
 */

export const logger = {
  error: (message: string, error?: any) => {
    if (error !== undefined) {
      console.error(message, error);
    } else {
      console.error(message);
    }
  },

  warn: (message: string, data?: any) => {
    if (import.meta.env.MODE === 'development') {
      if (data !== undefined) {
        console.warn(message, data);
      } else {
        console.warn(message);
      }
    }
  },

  info: (message: string, data?: any) => {
    if (import.meta.env.MODE === 'development') {
      if (data !== undefined) {
        console.info(message, data);
      } else {
        console.info(message);
      }
    }
  },

  debug: (message: string, data?: any) => {
    if (import.meta.env.MODE === 'development') {
      if (data !== undefined) {
        console.debug(message, data);
      } else {
        console.debug(message);
      }
    }
  },

  log: (message: string, data?: any) => {
    if (import.meta.env.MODE === 'development') {
      if (data !== undefined) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  }
};